<template>
  <div>
    <v-row align="center">
      <v-col cols="12" sm="8" md="4" lg="3" xl="2">
        <BusinessEntitiesDropDownList
          v-model="businessEntityId"
          label="Business Entity"
          :clearable="true"
        ></BusinessEntitiesDropDownList>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="2">
        <MonthPicker
          label="Month"
          :year="year"
          :month="month"
          @yearChange="(newValue) => this.year = newValue"
          @monthChange="(newValue) => this.month = newValue"
        ></MonthPicker>
      </v-col>
      <v-col cols="12" sm="8" md="5" lg="4" xl="3">
        <UsersDropDownList
          class="my-auto"
          label="Internal Employee"
          :userId="userId"
          :clearable="true"
          :securityRoles="[ADMIN, MANAGER, SALES_PERSON, RECRUITER]"
          @userIdChange="handleUserIdChange"
        ></UsersDropDownList>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { MonthPicker } from '@/components/shared/datePickers'
import { UsersDropDownList } from '@/components/users'
import { BusinessEntitiesDropDownList } from '@/components/businessEntities'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { ADMIN, MANAGER, SALES_PERSON, RECRUITER } from '@/lib/constants/securityRoles'

export default {
  components: {
    UsersDropDownList,
    BusinessEntitiesDropDownList,
    FilterButtons,
    FilterButtonsSmall,
    MonthPicker
  },
  data () {
    return {
      ADMIN,
      MANAGER,
      SALES_PERSON,
      RECRUITER
    }
  },
  computed: {
    ...mapFields('commissionReportFilters', [
      'businessEntityId',
      'userId',
      'year',
      'month'
    ])
  },
  methods: {
    ...mapActions('commissionReportFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleUserIdChange (newValue) {
      this.userId = newValue
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  },
  created () {
    this.$emit('search')
  }
}
</script>
